import { isString } from './isString'
import { getLocalizedSchemaAttributes } from './schemaLocalization'
import { SchemaAttributes, SchemaLabel } from '@/Data/types'

/**
 * retrieves the labels from schema attributes
 * @param attributes schema attributes
 * @returns an array of labels; an empty array if not labels are specified by the schema
 */
export const getLabelsFromSchema = (
  attributes?: SchemaAttributes,
): SchemaLabel[] => {
  const localizedAttributes = getLocalizedSchemaAttributes(attributes)

  if (localizedAttributes) {
    const lables_attr = localizedAttributes.labels
    const values = lables_attr?.enumValues
    if (values && values.length > 0) {
      const labels: SchemaLabel[] = []
      values.forEach((value) => {
        if (isString(value.title) && isString(value.value)) {
          labels.push({
            title: value.title as string,
            value: value.value as string,
          })
        }
      })
      return labels
    }
  }
  return []
}
